<script setup>
import { computed } from 'vue';
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(() => `${props.row.original.type}_reports_show`);
</script>

<template>
  <span v-if="row.original.archived">{{ row.original.name }}</span>
  <router-link
    v-else
    :to="{ name: routeName, params: { id: row.original.id } }"
    class="text-n-slate-12 hover:underline"
  >
    {{ row.original.name }}
  </router-link>
</template>
